import { Button } from '@/components/ui'
import { firstWords, type Conversation } from './conversation'
import { DISCARD, KEEP_GOING, RESUME_LEAD, SEND_AS_IS, agoText, resumeLine, resumeQuote } from './helpFeedbackText'

/** On reopen, an unsent conversation with the person's words (decision 17). */
export function ResumeOffer({ c, now, disabled, onKeep, onSend, onDiscard }: {
  c: Conversation
  now: number
  disabled: boolean
  onKeep: () => void
  onSend: () => void
  onDiscard: () => void
}) {
  return (
    <div className="space-y-2 rounded-lg border border-section-border bg-card p-3 text-sm shadow-xs" data-testid="help-feedback-resume">
      <p className="font-medium">{RESUME_LEAD}</p>
      <p className="text-muted-foreground">{resumeLine(resumeQuote(firstWords(c)), c.page, agoText(now - c.startedAt))}</p>
      <div className="flex flex-wrap gap-2">
        <Button size="sm" onClick={onKeep}>{KEEP_GOING}</Button>
        <Button size="sm" variant="outline" onClick={onSend} disabled={disabled}>{SEND_AS_IS}</Button>
        <Button size="sm" variant="ghost" onClick={onDiscard}>{DISCARD}</Button>
      </div>
    </div>
  )
}
